import { createFileRoute } from '@tanstack/react-router'
import { DetectionConfigurationFormPage } from 'pages/anomalyDetection/DetectionConfigurationFormPage'
import { detectionConfigurationSearchParams } from 'routes/anomaly-detection/-searchParams'

const RouteComponent = () => {
  const { siteId, detectionConfigurationId } = Route.useSearch()

  return (
    <DetectionConfigurationFormPage
      siteId={siteId}
      detectionConfigurationId={detectionConfigurationId}
    />
  )
}

export const Route = createFileRoute('/anomaly-detection/config')({
  component: RouteComponent,
  validateSearch: detectionConfigurationSearchParams,
  staticData: {
    title: 'Detection Configuration',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: true,
    },
  },
})
